import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import React from 'react';
import IconButton from '@wix/da-ds/pkg/Buttons/IconButton';
import { useDropdownToggleProps } from '../../hooks/useDropdownToggleProps';
/**
 * A wrapper around our DS `IconButton` that provides the props for a dropdown toggle.
 *
 * Note: This component is only the toggle! It doesn't contain a popover or dropdown. If you're looking for something that does,
 * you probably want a preset instead of this. Consider `IconButtonWithContextMenu`.
 *
 * Required contexts: `PopperDropdownContext`, `DropdownStateContext`
 */ const PopperIconToggleButton = (props)=>{
    const necessaryToggleProps = useDropdownToggleProps();
    return /*#__PURE__*/ React.createElement(IconButton, _object_spread({}, necessaryToggleProps, props));
};
PopperIconToggleButton.displayName = 'PopperIconToggleButton';
export default PopperIconToggleButton;
